<template>
  <div class="home">

    <!-- <img alt="Vue logo" src="@/assets/IOIHANlogo300x502.png"> -->
    <!-- <br> -->

    <h1>Report Sample</h1>


    <report-control
      title="Transaction Detail Report"
      >
    </report-control>

  </div>
</template>

<script>
  // @ is an alias to /src

  import axios from 'axios';
  import ReportControl from '@/components/ReportControl';

  export default {
    name      : 'Report',
    components: {
      ReportControl
    },
    data() {
      return {
        reportName  : "TransactionDetail",
        reportConfig: null,
        reportData  : null
      }
    }
    ,
    created() {
      
    },
    methods   : {
      async getReport(report) {

        report = encodeURIComponent(report);

        try {
          // look how we're doing this in the catering module - once we get the api key it will be good for several days as long as nothing changes.
          let apiKey = "<need this>";
          let response = await axios({ method: 'get', url: `https://sandbox.ioihan.com:9040/api/1/report/${report}` });
          this.reportConfig = response.data;
          console.log( JSON.stringify(response.data,null,2));

        } catch( error ) {
          this.reportConfig = null;              // just disable this on error -  it's not critical and this service has a rate limit...
          console.log( "oops" , error );
        }
      }
    }
  }

</script>

<style lang="scss" scoped>

  .quote-card {
    width: 60%;
    position: relative;
    text-align: center;

    margin:auto;
    margin-top:3em;
    padding:10px;
  }
   .quote-image {
      position:relative;
      width:100%;
      height: auto;
      border-radius: 2em;
      border: 5px black solid;
      -webkit-box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
      box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    }

    .quote-text {
      position:absolute ;
      color: #111;
      top:120px;
      left:50%;
      font-family: Helvetica sans-serif;
      font-size:28px;
      line-height:1em;
      font-weight:800;
      //text-shadow: -4px 5px 5px #130228;
      // text-shadow: -4px 5px 19px rgba(19,2,40,0.98);
      text-shadow: -4px 5px 19px rgba(240,240,240,1);
      width: 80%;
      text-align:center;
      transform: translate(-50%, -50%);

      span:before {
        content: "-";
        font-size: 12px;
        color:black;
        padding-left: 2em;
      }

      span {
        content: "eee";
        font-style: italic;
        font-size: 12px;
        color:black;
        padding-left:1em;
        float:right;
      }
    }


  .quote-credits {
    position:absolute;
    font-size:18px;
    bottom:20px;
    left:10%;
    color: white;
    a {
      font-style:italic;
      color:white;
    }
  }

  @media screen and (max-width: 1024px) {

    .quote-text {
      top:90px;
      font-size:16px;
    }

    .quote-credits {
      font-size:12px;
    }
  }

  .cat-image {
    margin-top: 3em;
    border: 3px solid gray;
    -webkit-box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    box-shadow: -12px 12px 15px 2px rgba(0, 0, 0, 0.72);
    border-radius: 50%;
  }

</style>
